module.exports = __webpack_public_path__ + "img/reference_cutting.54df367d.jpg";